import { createContext, useContext, useEffect, useRef } from "react";
import { getWebSocketClient, WebSocketClient } from "./wsClient";

const WebSocketContext = createContext<WebSocketClient | null>(null);

export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const wsRef = useRef<WebSocketClient | null>(null);

  useEffect(() => {
    // Get singleton client
    const ws = getWebSocketClient();
    wsRef.current = ws;

    // Connect to WebSocket server
    const wsUrl =
      process.env.NODE_ENV !== "production"
        ? `ws://${window.location.hostname}:3000/connect`
        : "wss://zeusui.zeus-control.com/connect";

    ws.connect(wsUrl);

    // Cleanup on unmount
    return () => {
      // Don't disconnect - keep connection alive for SPA
      // ws.disconnect()
    };
  }, []);

  return (
    <WebSocketContext.Provider value={wsRef.current}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocket() {
  const ws = useContext(WebSocketContext);
  if (!ws) {
    throw new Error("useWebSocket must be used within WebSocketProvider");
  }
  return ws;
}
